
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexZke1Ztny2M2I9w8kPTX4e7m0Y0_45jiNnwfPpcoOwRx5YMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/index.vue?macro=true";
import { default as loginl4gYlAqkEJYM9QJvJTgh35IdnEkH1uOZ2S_45oOtaWStEMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/login.vue?macro=true";
import { default as print_45jobsM4GnKFknDu9hSw7yFmXCL0JenmKXP5Cn0EozdRz6rlkMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/print-jobs.vue?macro=true";
import { default as settlementnKxUoXL2m7ATGE1DGNk5XgO4ilA4yxkuP7xEhXthKWUMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/settlement.vue?macro=true";
import { default as _91id_93dZrEFrnG60JMEm76_qSq95Waq9ZTQhquAysW_8lvzQ4Meta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/[id].vue?macro=true";
import { default as indexw8AKg5vDaRYJhs9XAIyvm5JGFYP91ld_45vuk0B800q2gMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/index.vue?macro=true";
import { default as indexP3wgNunwf4RNrX4UppAQfjAAg4FdYSXhpZgNmc1e__458Meta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/index.vue?macro=true";
import { default as indexUjWb1XfJ7UbjgxF6s_45bZgWaGg07_O4AkhDJJPVKZ86wMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/index.vue?macro=true";
import { default as indexRXeBXK9XWa1RdEcVz1aNcNEdUXjvhzWurpH_45f2icexAMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/index.vue?macro=true";
import { default as createSGgDih1naSS6Hni66PTcwQkwkCs_454NatPJwJh9zByBQMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/create.vue?macro=true";
import { default as create9UpjIhHZyK2ybjTEXvS9OGfZcJQqqXijFCaDiyWpPFUMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId]/orders/create.vue?macro=true";
import { default as _91orderId_932zqIxGRPywbKr1kE1D8iYzdVss_xvgi_45OEHDDEflJ2oMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId]/orders/[orderId].vue?macro=true";
import { default as _91tableId_93_45MsaFRRNuh8wgmfZIRl6w1EZddD6T6TIXjkOGSSu8sIMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId].vue?macro=true";
import { default as indexsP1hvjmz7EpnP_JS7m1pDAGfDKgNZCkA6nqAXGMwvRIMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/reservations/index.vue?macro=true";
import { default as lanesoef7LhoLcVRbtHm1iWSyibDOQoUpU_NwcXoQiaQ2ffcMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/reservations/lanes.vue?macro=true";
import { default as _91value_93nqAqBtcIUGfIzphec2GXBX7tLjaxHUKeJ8p6h7E4_zMMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/code/[value].vue?macro=true";
import { default as _91id_93S4xMqIFZFPLQ6n9xGt_s8JTC_JJMMEzqu53Ig_IHdMMMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/[id].vue?macro=true";
import { default as createmNi967BjfKkvGXWrHJlJjhs2Sjfc9FpQokHvZXa_GFsMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/statuses/create.vue?macro=true";
import { default as indexZlGcoSYlrANMBHt1Rl58twixt_45R0XoLgHmfTVVFUDQwMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/index.vue?macro=true";
import { default as createjRpq_45IoGZxnMoB38gZMUR3dOYQjvGZnDL0ScTA3dEmoMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/create.vue?macro=true";
import { default as indexJiGcWmK5S8c4mi29nyrMDw0aWXSYP_fdtwi6F5u_45pKcMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/[merchantId]/index.vue?macro=true";
import { default as inQ9TyJknLMCJT20E_45NjleIsGqeKi1T_T1UB_AdHQOVXsMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/transfers/create/in.vue?macro=true";
import { default as out3SMBitbUnnSOxQZaZI8i_45KXUbINKq7_45AELYoS_45ozTIUMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/transfers/create/out.vue?macro=true";
import { default as _91storeId_937f4nN7B9sISUvxZnJHvLghcuS8VTLey99vxlFY6XILYMeta } from "/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/[merchantId]/stores/[storeId].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexZke1Ztny2M2I9w8kPTX4e7m0Y0_45jiNnwfPpcoOwRx5YMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginl4gYlAqkEJYM9QJvJTgh35IdnEkH1uOZ2S_45oOtaWStEMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/login.vue")
  },
  {
    name: "print-jobs",
    path: "/print-jobs",
    meta: print_45jobsM4GnKFknDu9hSw7yFmXCL0JenmKXP5Cn0EozdRz6rlkMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/print-jobs.vue")
  },
  {
    name: "settlement",
    path: "/settlement",
    meta: settlementnKxUoXL2m7ATGE1DGNk5XgO4ilA4yxkuP7xEhXthKWUMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/settlement.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/[id].vue")
  },
  {
    name: "setup",
    path: "/setup",
    meta: indexw8AKg5vDaRYJhs9XAIyvm5JGFYP91ld_45vuk0B800q2gMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/index.vue")
  },
  {
    name: "stock",
    path: "/stock",
    meta: indexP3wgNunwf4RNrX4UppAQfjAAg4FdYSXhpZgNmc1e__458Meta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    meta: indexUjWb1XfJ7UbjgxF6s_45bZgWaGg07_O4AkhDJJPVKZ86wMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/index.vue")
  },
  {
    name: "tables",
    path: "/tables",
    meta: indexRXeBXK9XWa1RdEcVz1aNcNEdUXjvhzWurpH_45f2icexAMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/index.vue")
  },
  {
    name: "orders-create",
    path: "/orders/create",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/orders/create.vue")
  },
  {
    name: "tables-tableId",
    path: "/tables/:tableId()",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId].vue"),
    children: [
  {
    name: "tables-tableId-orders-create",
    path: "orders/create",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId]/orders/create.vue")
  },
  {
    name: "tables-tableId-orders-orderId",
    path: "orders/:orderId()",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/tables/[tableId]/orders/[orderId].vue")
  }
]
  },
  {
    name: "reservations",
    path: "/reservations",
    meta: indexsP1hvjmz7EpnP_JS7m1pDAGfDKgNZCkA6nqAXGMwvRIMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/reservations/index.vue")
  },
  {
    name: "reservations-lanes",
    path: "/reservations/lanes",
    meta: lanesoef7LhoLcVRbtHm1iWSyibDOQoUpU_NwcXoQiaQ2ffcMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/reservations/lanes.vue")
  },
  {
    name: "setup-code-value",
    path: "/setup/code/:value()",
    meta: _91value_93nqAqBtcIUGfIzphec2GXBX7tLjaxHUKeJ8p6h7E4_zMMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/code/[value].vue")
  },
  {
    name: "takeaway-orders-id",
    path: "/takeaway-orders/:id()",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/[id].vue")
  },
  {
    name: "stock-statuses-create",
    path: "/stock/statuses/create",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/statuses/create.vue")
  },
  {
    name: "takeaway-orders",
    path: "/takeaway-orders",
    meta: indexZlGcoSYlrANMBHt1Rl58twixt_45R0XoLgHmfTVVFUDQwMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/index.vue")
  },
  {
    name: "takeaway-orders-create",
    path: "/takeaway-orders/create",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/takeaway-orders/create.vue")
  },
  {
    name: "setup-merchantId",
    path: "/setup/:merchantId()",
    meta: indexJiGcWmK5S8c4mi29nyrMDw0aWXSYP_fdtwi6F5u_45pKcMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/[merchantId]/index.vue")
  },
  {
    name: "stock-transfers-create-in",
    path: "/stock/transfers/create/in",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/transfers/create/in.vue")
  },
  {
    name: "stock-transfers-create-out",
    path: "/stock/transfers/create/out",
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/stock/transfers/create/out.vue")
  },
  {
    name: "setup-merchantId-stores-storeId",
    path: "/setup/:merchantId()/stores/:storeId()",
    meta: _91storeId_937f4nN7B9sISUvxZnJHvLghcuS8VTLey99vxlFY6XILYMeta || {},
    component: () => import("/var/www/sites/terminal.ultrafedt.dk/releases/20260311213325/pages/setup/[merchantId]/stores/[storeId].vue")
  }
]